// life is so much simpler with a US-only product and customer base...

export const currencyFormatterUSD = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'})

export function formatCurrencyUSD(value: number): string {
  return currencyFormatterUSD.format(value)
}

// imports may want to alias this to something shorter
export function formatCurrencyUSDWholeDollars(value: number): string {
  return currencyFormatterUSD.format(Math.round(value)).replace(/\.00$/, '')
}
